import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import "./App.css";
import "./index.css";

import PublicLayout from "./components/PublicLayout";
import Home from "./pages/Home";
import About from "./pages/About";
import Pricing from "./pages/Pricing";
import Areas from "./pages/Areas";
import Contact from "./pages/Contact";
import Reviews from "./pages/Reviews";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Book from "./pages/Book";
import BookSuccess from "./pages/BookSuccess";
import Packages from "./pages/Packages";
import PackageDetail from "./pages/PackageDetail";
import IntensiveOfferPage from "./pages/IntensiveOfferPage";
import LegalPage from "./pages/LegalPage";
import AuthCallback from "./pages/AuthCallback";
import ScrollToTop from "./components/ScrollToTop";
import AdminLogin from "./pages/admin/Login";
import AdminLayout from "./pages/admin/AdminLayout";
import { AdminAuthProvider, ProtectedAdminRoute } from "./pages/admin/AdminAuth";
import AdminCalendar from "./pages/admin/AdminCalendar";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminBlog from "./pages/admin/AdminBlog";
import AdminPagesCMS from "./pages/admin/AdminPagesCMS";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminEnquiries from "./pages/admin/AdminEnquiries";
import AdminIntensiveOffers from "./pages/admin/AdminIntensiveOffers";
import AdminMedia from "./pages/admin/AdminMedia";

function AppRouter() {
  const location = useLocation();
  // CRITICAL: handle session_id BEFORE any other routing logic
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      {/* Public marketing site */}
      <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
      <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
      <Route path="/pricing/:type" element={<PublicLayout><Pricing /></PublicLayout>} />
      <Route path="/pricing" element={<PublicLayout><Pricing /></PublicLayout>} />
      <Route path="/areas-covered" element={<PublicLayout><Areas /></PublicLayout>} />
      <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
      <Route path="/reviews" element={<PublicLayout><Reviews /></PublicLayout>} />
      <Route path="/blog" element={<PublicLayout><Blog /></PublicLayout>} />
      <Route path="/blog/:slug" element={<PublicLayout><BlogPost /></PublicLayout>} />
      <Route path="/book" element={<PublicLayout><Book /></PublicLayout>} />
      <Route path="/booking/success" element={<PublicLayout><BookSuccess /></PublicLayout>} />
      <Route path="/packages" element={<PublicLayout><Packages /></PublicLayout>} />
      <Route path="/packages/:slug" element={<PublicLayout><PackageDetail /></PublicLayout>} />
      <Route path="/intensive-offer/:offer_id" element={<PublicLayout><IntensiveOfferPage /></PublicLayout>} />
      <Route path="/privacy" element={<PublicLayout><LegalPage slug="privacy" defaultTitle="Privacy Policy" defaultSubtitle="How Lime Driving School handles your data." /></PublicLayout>} />
      <Route path="/terms" element={<PublicLayout><LegalPage slug="terms" defaultTitle="Terms" defaultSubtitle="The conditions that apply to booking lessons with us." /></PublicLayout>} />
      <Route path="/refund-policy" element={<PublicLayout><LegalPage slug="refund-policy" defaultTitle="Cancellation and Refund Policy" defaultSubtitle="Notice periods, refunds and rescheduling rules." /></PublicLayout>} />

      {/* Admin */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<ProtectedAdminRoute><AdminLayout><AdminCalendar /></AdminLayout></ProtectedAdminRoute>} />
      <Route path="/admin/orders" element={<ProtectedAdminRoute><AdminLayout><AdminOrders /></AdminLayout></ProtectedAdminRoute>} />
      <Route path="/admin/blog" element={<ProtectedAdminRoute><AdminLayout><AdminBlog /></AdminLayout></ProtectedAdminRoute>} />
      <Route path="/admin/pages" element={<ProtectedAdminRoute><AdminLayout><AdminPagesCMS /></AdminLayout></ProtectedAdminRoute>} />
      <Route path="/admin/settings" element={<ProtectedAdminRoute><AdminLayout><AdminSettings /></AdminLayout></ProtectedAdminRoute>} />
      <Route path="/admin/enquiries" element={<ProtectedAdminRoute><AdminLayout><AdminEnquiries /></AdminLayout></ProtectedAdminRoute>} />
      <Route path="/admin/intensive-offers" element={<ProtectedAdminRoute><AdminLayout><AdminIntensiveOffers /></AdminLayout></ProtectedAdminRoute>} />
      <Route path="/admin/media" element={<ProtectedAdminRoute><AdminLayout><AdminMedia /></AdminLayout></ProtectedAdminRoute>} />

      <Route path="*" element={<PublicLayout><div className="py-32 text-center text-[#9CA3AF]">Page not found.</div></PublicLayout>} />
    </Routes>
  );
}

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <AdminAuthProvider>
          <AppRouter />
          <Toaster richColors position="top-right" />
        </AdminAuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}
